import IntegrationCard from '../../../../../components/integration-card/IntegrationCard';
import AtosaLogo from '../../../../../assets/atosa.png';

type FirmAtosaIntegrationCardProps = {
    status: 'CONNECTED' | 'ISSUE' | 'DEFAULT';
    onConfigure: (id: string) => void;
};

function FirmAtosaIntegrationCard({ status, onConfigure }: FirmAtosaIntegrationCardProps): JSX.Element {
    return (
        <IntegrationCard
            id="atosa"
            title="Atosa"
            description="Connect Atosa to Cimplico Workpapers"
            status={status}
            logo={AtosaLogo}
            onConfigure={onConfigure}
            _new
        />
    );
}

export default FirmAtosaIntegrationCard;
